import React from 'react';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/lib/Button';
import Table from 'react-bootstrap/lib/Table';

import { prettyKey, formatEmptyTableData } from '../helpers/formatters';

const CustomPlanPricingList = ({
  customPlanPricingList = [],
  handleOpenDeleteModal,
  handleOpenUpdateModal,
  canModify,
}) => (
  <div>
    <Table className="mar-t custom-table" striped condensed hover responsive>
      <thead>
        <tr>
          <th>ID</th>
          <th>AT&amp;T Plan</th>
          <th style={{ whiteSpace: 'nowrap' }}>AT&amp;T Plan Name</th>
          <th>Simo Plan</th>
          <th style={{ whiteSpace: 'nowrap' }}>Simo Plan Name</th>
          <th>Quick Plan</th>
          <th style={{ whiteSpace: 'nowrap' }}>Quick Plan Name</th>
          <th>User Profile</th>
          <th>Activation Fee</th>
          <th>Price</th>
          <th>Visible</th>
          <th>Effective</th>
          {canModify && (
            <React.Fragment>
              <th>Update</th>
              <th>Delete</th>
            </React.Fragment>
          )}
          <th></th>
        </tr>
      </thead>
      <tbody>
        {Boolean(customPlanPricingList.length) &&
          customPlanPricingList.map((customPlanPricing) => (
            <tr className="custom-plan-table-row" key={customPlanPricing.id}>
              <td className="text-center">{customPlanPricing.id}</td>
              <td className="text-center">
                {formatEmptyTableData(customPlanPricing.att_plan)}
              </td>
              <td className="text-center">{customPlanPricing.att_plan_name}</td>
              <td className="text-center">
                {formatEmptyTableData(customPlanPricing.simo_plan)}
              </td>
              <td className="text-center">
                {customPlanPricing.simo_plan_name}
              </td>
              <td className="text-center">
                {formatEmptyTableData(customPlanPricing.quick_plan)}
              </td>
              <td className="text-center">
                {customPlanPricing.quick_plan_name}
              </td>
              <td className="text-center">{customPlanPricing.user_profile}</td>
              <td className="text-center">
                {customPlanPricing.activation_fee}
              </td>
              <td className="text-center">{customPlanPricing.price}</td>
              <td className="text-center">
                {prettyKey(`${customPlanPricing.is_visible}`)}
              </td>
              <td className="text-center">
                {prettyKey(`${customPlanPricing.is_effective}`)}
              </td>
              {canModify && customPlanPricing.is_effective && (
                <React.Fragment>
                  <td>
                    <Button
                      className="small-bs-btn"
                      bsStyle="warning"
                      onClick={() => handleOpenUpdateModal(customPlanPricing)}
                    >
                      Update
                    </Button>
                  </td>
                  <td>
                    <Button
                      className="small-bs-btn"
                      bsStyle="danger"
                      onClick={() => handleOpenDeleteModal(customPlanPricing)}
                    >
                      Delete
                    </Button>
                  </td>
                </React.Fragment>
              )}
              <td>
                &nbsp;&nbsp;
                <Link to={`/custom-plan-prices/${customPlanPricing.id}`}>
                  View
                </Link>
                &nbsp;&nbsp;
              </td>
            </tr>
          ))}
      </tbody>
    </Table>

    {!Boolean(customPlanPricingList.length) && <span>Not found</span>}
  </div>
);

export default CustomPlanPricingList;
